import angular from 'angular';

import CheckEventCountDirective, { selector } from './check-event-count.directive';

export default angular
    .module('application.scene.authorized.scene.calendar.directive.check-event-count', [])
    .directive(selector, CheckEventCountDirective);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/directive/check-event-count/index.js